export default "__VITE_ASSET__Cd7O0cUq__"